import React from "react";
import CarousalImage from "../../../images/carousal_image.svg";
import propertyImage from "../../../images/property_image.svg";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";
const LoginInfo = () => {
  const { _t } = useTranslator();
  return (
    <div className="position-relative z-2">
      <div className="cardWidth">
        <div className="carousal_card d-flex gap-1 position-relative">
          <div className="carousal_content">
            <h4>{_t("delicious_dried_mango", "Delicious dried mango")}</h4>
            <p>
              {_t(
                "mexico_facility_description",
                "We operate a 30,000 sq.ft. state of the art facility in Mexico, which allows us to complete the entire farming and manufacturing of the product in house."
              )}
            </p>
            <Button
              className="btn-medium"
              label={_t("learn_more", "Learn more")}
              loading={false}
            />
          </div>
          <div className="carousal_image">
            <img
              src={CarousalImage}
              alt="carosual-image"
              className="img-fluid"
            />
          </div>
          <div className="area_info d-flex gap-2 position-absolute">
            <img
              src={propertyImage}
              alt="carosual-image"
              className="img-fluid"
            />
            <div className="area_content">
              <h6 className="m-0">
                {_t(
                  "facility_refrigeration",
                  "Contains a large refrigeration center"
                )}
              </h6>
              <h5>{_t("facility_size", "30,000 Sq. Ft")}</h5>
            </div>
          </div>
        </div>
        <div className="area_information">
          <h4 className="text-white">
            {_t("facility_ovens", "6 State of the Art Ovens")}
          </h4>
          <p className="mb-0 text-white">
            {_t(
              "facility_production",
              "Our 120 team members produce 5,300 LBs of Dried Mango Daily."
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginInfo;
